import { Store } from "../utils/Storage";
import {execute, executeSecure} from "../utils/amplify-api.utils";
import {mapStoreDataToAssistantFields, mapStoreDataToPassportFields} from "../utils/passport.utils";
import {
    createPassport,
    updatePassport,
    createPassportFile,
    updatePassportFile,
    deletePassportFile,
    createAssistant,
    updateAssistant,
    createPassportSec,
    updatePassportSec,
    createPassportFileSec,
    updatePassportFileSec, deletePassportFileSec,
} from "../graphql/mutations";
import {getAssistant, getPassport, getPassportSec, listPassportFiles, listPassportFileSecs} from "../graphql/queries";
import { IProfileMood } from "../contexts/Auth/Auth";
import { DeletePassportFileInput, UpdatePassportFileInput } from "../API";

interface IData {
  id: string;
  profile_mood: IProfileMood[];
}

export const createPassportDynaDBData = async (id: string, password: string) =>
  executeSecure(
    {
      statement: createPassportSec,
      name: "createPassportSec",
    },
    { input: { id, password } }
  );

export const updatePassportData = async (store: Partial<Store>) =>
  executeSecure(
    {
      statement: updatePassportSec,
      name: "updatePassportSec",
    },
    {
      input: mapStoreDataToPassportFields(store),
    }
  );

export const updateProfileMoodPassportData = async (data: IData) => {
  return executeSecure(
    {
      statement: updatePassportSec,
      name: "updatePassportSec",
    },
    {
      input: {
        id: data.id,
        profile_mood: data.profile_mood,
      },
    }
  );
};

export const updatePasswordOfPassportData = async (id: string, password: string) => {
  return executeSecure(
    {
      statement: updatePassportSec,
      name: "updatePassportSec",
    },
    {
      input: {
        id,
        password
      },
    }
  );
};

export const getPassportDataFromDynaDB = async (id: string) =>
  executeSecure(
    {
      statement: getPassportSec,
      name: "getPassportSec",
    },
    { id }
  );

export const generatePassportFile = async (data: any) =>
  executeSecure(
    {
      statement: createPassportFileSec,
      name: "createPassportFileSec",
    },
    { input: data }
  );

export const getPassportFilesByPassportId = async (passportId: string) =>
  executeSecure(
    {
      statement: listPassportFileSecs,
      name: "listPassportFileSecs",
    },
    {
      filter: {
        passportId: { eq: passportId },
      },
    }
  );

export const updatePassportFileById = async (data: UpdatePassportFileInput) =>
  executeSecure(
    {
      statement: updatePassportFileSec,
      name: "updatePassportFileSec",
    },
    { input: data }
  );

export const deletePassportFileById = async (id: string) =>
  executeSecure(
    {
      statement: deletePassportFileSec,
      name: "deletePassportFileSec",
    },
    { input: { id } }
  );

export const createAssistantData = async (id: string) =>
  executeSecure(
    {
        statement: createAssistant,
        name: "createAssistant",
    },
    { input: { id } }
  );

export const updateAssistantData = async (store: Partial<Store>) =>
  executeSecure(
    {
        statement: updateAssistant,
        name: "updateAssistant",
    },
    {
        input: mapStoreDataToAssistantFields(store),
    }
  );

export const getAssistantData = async (id: string) =>
  executeSecure(
    {
        statement: getAssistant,
        name: "getAssistant",
    },
    { id }
  );
